import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardHeader, CardBody, CardFooter } from '../components/ui/Card';
import { CtaSection } from '../components/sections/CtaSection';
import { MapPinIcon, UsersIcon, StarIcon, CalendarIcon, CheckIcon } from 'lucide-react';
export function Venues() {
  const [activeFilters, setActiveFilters] = useState({
    size: 'all',
    csrScore: 'all',
    vibe: 'all',
    buyout: 'all',
    distance: 'all'
  });
  const venues = [{
    name: 'Oceanfront Luxury Resort',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    capacity: 350,
    distance: 25,
    csrScore: 'A+',
    vibe: 'Luxury',
    buyout: true,
    perk: 'Private beach cove',
    rate: '$$$',
    filters: {
      size: 'large',
      csrScore: 'high',
      vibe: 'luxury',
      buyout: 'yes',
      distance: 'medium'
    }
  }, {
    name: 'Beachfront Boutique Hotel',
    image: 'https://images.unsplash.com/photo-1540541338287-41700207dee6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    capacity: 120,
    distance: 15,
    csrScore: 'A',
    vibe: 'Boutique',
    buyout: true,
    perk: 'Rooftop infinity pool',
    rate: '$$',
    filters: {
      size: 'medium',
      csrScore: 'high',
      vibe: 'boutique',
      buyout: 'yes',
      distance: 'close'
    }
  }, {
    name: 'Eco Adventure Resort',
    image: 'https://images.unsplash.com/photo-1586375300773-8384e3e4916f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    capacity: 200,
    distance: 35,
    csrScore: 'A+',
    vibe: 'Adventure',
    buyout: false,
    perk: 'Private cenote access',
    rate: '$$',
    filters: {
      size: 'medium',
      csrScore: 'high',
      vibe: 'adventure',
      buyout: 'no',
      distance: 'far'
    }
  }, {
    name: 'Modern All-Inclusive Resort',
    image: 'https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    capacity: 500,
    distance: 20,
    csrScore: 'B+',
    vibe: 'Luxury',
    buyout: false,
    perk: '24/7 all-inclusive service',
    rate: '$$$',
    filters: {
      size: 'large',
      csrScore: 'medium',
      vibe: 'luxury',
      buyout: 'no',
      distance: 'medium'
    }
  }, {
    name: 'Secluded Jungle Retreat',
    image: 'https://images.unsplash.com/photo-1596394516093-501ba68a0ba6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    capacity: 80,
    distance: 45,
    csrScore: 'A+',
    vibe: 'Boutique',
    buyout: true,
    perk: 'Immersive nature experience',
    rate: '$$',
    filters: {
      size: 'small',
      csrScore: 'high',
      vibe: 'boutique',
      buyout: 'yes',
      distance: 'far'
    }
  }, {
    name: 'Urban Luxury Hotel',
    image: 'https://images.unsplash.com/photo-1618773928121-c32242e63f39?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    capacity: 300,
    distance: 5,
    csrScore: 'B',
    vibe: 'Luxury',
    buyout: false,
    perk: 'Rooftop helipad',
    rate: '$$$',
    filters: {
      size: 'large',
      csrScore: 'medium',
      vibe: 'luxury',
      buyout: 'no',
      distance: 'close'
    }
  }];
  const filterOptions = {
    size: [{
      value: 'all',
      label: 'All Sizes'
    }, {
      value: 'small',
      label: 'Small (< 100)'
    }, {
      value: 'medium',
      label: 'Medium (100-300)'
    }, {
      value: 'large',
      label: 'Large (300+)'
    }],
    csrScore: [{
      value: 'all',
      label: 'All CSR Scores'
    }, {
      value: 'high',
      label: 'High (A/A+)'
    }, {
      value: 'medium',
      label: 'Medium (B/B+)'
    }],
    vibe: [{
      value: 'all',
      label: 'All Vibes'
    }, {
      value: 'luxury',
      label: 'Luxury'
    }, {
      value: 'boutique',
      label: 'Boutique'
    }, {
      value: 'adventure',
      label: 'Adventure'
    }],
    buyout: [{
      value: 'all',
      label: 'All Options'
    }, {
      value: 'yes',
      label: 'Buyout Available'
    }, {
      value: 'no',
      label: 'Partial Booking'
    }],
    distance: [{
      value: 'all',
      label: 'All Distances'
    }, {
      value: 'close',
      label: 'Close (< 20 min)'
    }, {
      value: 'medium',
      label: 'Medium (20-30 min)'
    }, {
      value: 'far',
      label: 'Far (30+ min)'
    }]
  };
  const handleFilterChange = (category, value) => {
    setActiveFilters({
      ...activeFilters,
      [category]: value
    });
  };
  const filteredVenues = venues.filter(venue => {
    return Object.keys(activeFilters).every(filter => {
      return activeFilters[filter] === 'all' || venue.filters[filter] === activeFilters[filter];
    });
  });
  return <div className="pt-20 bg-[#F4E8D0]/30" data-id="element-3138">
      {/* Hero */}
      <section className="bg-[#0099A1] py-20" data-id="element-3139">
        <div className="container mx-auto px-4 md:px-6" data-id="element-3140">
          <div className="max-w-3xl" data-id="element-3141">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-3142">
              Venues
            </h1>
            <p className="text-xl text-white/90" data-id="element-3143">
              Discover world-class resorts and venues for your next corporate
              event in Cancun & Riviera Maya.
            </p>
          </div>
        </div>
      </section>

      {/* Flight Accessibility */}
      <section className="py-12 bg-white" data-id="element-3144">
        <div className="container mx-auto px-4 md:px-6" data-id="element-3145">
          <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-3146">
            <h2 className="text-2xl font-bold text-[#374047] mb-2" data-id="element-3147">
              Easy to Reach from Anywhere
            </h2>
            <p className="text-[#374047]/70" data-id="element-3148">
              ~3,000 direct flights/month to CUN; most under 4 hours from major
              North American hubs.
            </p>
          </div>

          {/* Flight Map Image */}
          <div className="max-w-5xl mx-auto mb-8" data-id="element-3149">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jgaeJ2aNiCgZhf3ffiikef/Cancun_Map_%283%29.webp" alt="Flight routes to Cancun from major North American cities" className="w-full rounded-lg shadow-lg" data-id="element-3150" />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-5xl mx-auto" data-id="element-3151">
            <div className="bg-[#F4E8D0]/30 rounded-lg p-4 text-center" data-id="element-3152">
              <div className="text-2xl font-bold text-[#0099A1] mb-1" data-id="element-3153">2.5h</div>
              <div className="text-sm text-[#374047]" data-id="element-3154">Houston</div>
            </div>
            <div className="bg-[#F4E8D0]/30 rounded-lg p-4 text-center" data-id="element-3155">
              <div className="text-2xl font-bold text-[#0099A1] mb-1" data-id="element-3156">3h</div>
              <div className="text-sm text-[#374047]" data-id="element-3157">Dallas</div>
            </div>
            <div className="bg-[#F4E8D0]/30 rounded-lg p-4 text-center" data-id="element-3158">
              <div className="text-2xl font-bold text-[#0099A1] mb-1" data-id="element-3159">3.5h</div>
              <div className="text-sm text-[#374047]" data-id="element-3160">Atlanta</div>
            </div>
            <div className="bg-[#F4E8D0]/30 rounded-lg p-4 text-center" data-id="element-3161">
              <div className="text-2xl font-bold text-[#0099A1] mb-1" data-id="element-3162">3.5h</div>
              <div className="text-sm text-[#374047]" data-id="element-3163">Miami</div>
            </div>
            <div className="bg-[#F4E8D0]/30 rounded-lg p-4 text-center" data-id="element-3164">
              <div className="text-2xl font-bold text-[#0099A1] mb-1" data-id="element-3165">4h</div>
              <div className="text-sm text-[#374047]" data-id="element-3166">New York</div>
            </div>
            <div className="bg-[#F4E8D0]/30 rounded-lg p-4 text-center" data-id="element-3167">
              <div className="text-2xl font-bold text-[#0099A1] mb-1" data-id="element-3168">4h</div>
              <div className="text-sm text-[#374047]" data-id="element-3169">Chicago</div>
            </div>
            <div className="bg-[#F4E8D0]/30 rounded-lg p-4 text-center" data-id="element-3170">
              <div className="text-2xl font-bold text-[#0099A1] mb-1" data-id="element-3171">4.5h</div>
              <div className="text-sm text-[#374047]" data-id="element-3172">Los Angeles</div>
            </div>
            <div className="bg-[#F4E8D0]/30 rounded-lg p-4 text-center" data-id="element-3173">
              <div className="text-2xl font-bold text-[#0099A1] mb-1" data-id="element-3174">4.5h</div>
              <div className="text-sm text-[#374047]" data-id="element-3175">Toronto</div>
            </div>
          </div>
        </div>
      </section>

      {/* Venue Filters */}
      <section className="py-12 bg-[#F4E8D0]/30" data-id="element-3176">
        <div className="container mx-auto px-4 md:px-6" data-id="element-3177">
          <h2 className="text-2xl font-bold text-[#374047] mb-6" data-id="element-3178">
            Find Your Perfect Venue
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8" data-id="element-3179">
            {Object.keys(filterOptions).map(filterCategory => <div key={filterCategory} data-id="element-3180">
                <label className="block text-sm font-medium text-[#374047] mb-2" data-id="element-3181">
                  {filterCategory === 'csrScore' ? 'CSR Score' : filterCategory.charAt(0).toUpperCase() + filterCategory.slice(1)}
                </label>
                <select value={activeFilters[filterCategory]} onChange={e => handleFilterChange(filterCategory, e.target.value)} className="w-full p-2 border border-gray-300 rounded-md focus:ring-[#0099A1] focus:border-[#0099A1]" data-id="element-3182">
                  {filterOptions[filterCategory].map(option => <option key={option.value} value={option.value} data-id="element-3183">
                      {option.label}
                    </option>)}
                </select>
              </div>)}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3184">
            {filteredVenues.map((venue, index) => <Card key={index} className="h-full overflow-hidden" data-id="element-3185">
                <div className="h-48 overflow-hidden" data-id="element-3186">
                  <img src={venue.image} alt={venue.name} className="w-full h-full object-cover" data-id="element-3187" />
                </div>
                <CardHeader data-id="element-3188">
                  <div className="flex justify-between items-start" data-id="element-3189">
                    <h3 className="text-xl font-bold text-[#374047]" data-id="element-3190">
                      {venue.name}
                    </h3>
                    <span className={`px-2 py-1 rounded text-xs font-medium ${venue.csrScore === 'A+' ? 'bg-green-100 text-green-800' : venue.csrScore === 'A' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-3191">
                      CSR: {venue.csrScore}
                    </span>
                  </div>
                </CardHeader>
                <CardBody data-id="element-3192">
                  <div className="space-y-2" data-id="element-3193">
                    <div className="flex items-center justify-between" data-id="element-3194">
                      <div className="flex items-center" data-id="element-3195">
                        <UsersIcon className="h-4 w-4 text-[#0099A1] mr-2" data-id="element-3196" />
                        <span className="text-sm" data-id="element-3197">
                          Max Capacity: {venue.capacity}
                        </span>
                      </div>
                      <div className="flex items-center" data-id="element-3198">
                        <MapPinIcon className="h-4 w-4 text-[#0099A1] mr-2" data-id="element-3199" />
                        <span className="text-sm" data-id="element-3200">
                          {venue.distance} min from CUN
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center justify-between" data-id="element-3201">
                      <div className="flex items-center" data-id="element-3202">
                        <StarIcon className="h-4 w-4 text-[#0099A1] mr-2" data-id="element-3203" />
                        <span className="text-sm" data-id="element-3204">Vibe: {venue.vibe}</span>
                      </div>
                      <div className="flex items-center" data-id="element-3205">
                        <span className="text-sm font-medium" data-id="element-3206">
                          {venue.rate}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-3207">
                      <CheckIcon className="h-4 w-4 text-[#0099A1] mr-2" data-id="element-3208" />
                      <span className="text-sm" data-id="element-3209">
                        Signature Perk: {venue.perk}
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-3210">
                      <CalendarIcon className="h-4 w-4 text-[#0099A1] mr-2" data-id="element-3211" />
                      <span className="text-sm" data-id="element-3212">
                        Buyout Available: {venue.buyout ? 'Yes' : 'No'}
                      </span>
                    </div>
                  </div>
                </CardBody>
                <CardFooter className="justify-center" data-id="element-3213">
                  <Button variant="primary" size="sm" to="https://form.typeform.com/to/x5iwnyZM" className="w-full" data-id="element-3214">
                    Learn More about this Venue
                  </Button>
                </CardFooter>
              </Card>)}
          </div>
          {filteredVenues.length === 0 && <div className="text-center py-12" data-id="element-3215">
              <p className="text-lg text-[#374047]" data-id="element-3216">
                No venues match your current filters. Please adjust your
                criteria.
              </p>
            </div>}
        </div>
      </section>

      {/* Resort Comparison */}
      <section className="py-12 bg-white" data-id="element-3217">
        <div className="container mx-auto px-4 md:px-6" data-id="element-3218">
          <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-3219">
            <h2 className="text-2xl font-bold text-[#374047] mb-2" data-id="element-3220">
              Resort Comparison Meter
            </h2>
            <p className="text-[#374047]/70" data-id="element-3221">
              Select venues above to compare their features side by side.
            </p>
          </div>
          <div className="bg-[#F4E8D0]/30 rounded-xl p-6 text-center" data-id="element-3222">
            <p className="text-[#374047]/70" data-id="element-3223">Select venues to compare</p>
          </div>
        </div>
      </section>

      <CtaSection data-id="element-3224" />
    </div>;
}